import { withTranslation } from "react-i18next";

import React, { Component } from 'react';
// import PropType from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { sellerRegister } from '../../Action/registration';
import { withRouter } from 'react-router-dom';
import { Footer, Header, LoginHeader } from '../Common';
import SimpleReactValidator from 'simple-react-validator';
import { GoogleLoginItem } from '../Login/GoogleLoginItem';
import { FacebookLoginItem } from '../Login/FacebookLoginItem';
import {FacebookFirebaseLogin, GoogleFirebaseLogin} from "../components";
// import sellerRegisterAction from 'sellerRegister';

class SellerRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            email: '',
            user_type: 2,
            errors: []
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('3')}`,
            max: `:attribute :max ${this.props.t('1')} .`,
            required: ` :attribute ${this.props.t('10')}`,
            min: `:attribute :min ${this.props.t('2')}`,
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            if(nextProps.errors.errors === 'EMAIL_ALREADY_EXIST'){
                nextProps.errors.errors = this.props.t('13');
            }
            this.setState({ errors: nextProps.errors })
        }
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        document.getElementById("step1").disabled = true;
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {
                email: this.state.email,
            }
            this.props.sellerRegister(data, this.props.history);
        } else {
            this.validator.showMessages();
        }
    }
    render() {
        const { errors } = this.state.errors;

        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="mt-5">
                            <div className="col-md-12 tr_blank_big"></div>
                            <div className="">
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <div className="big_text" style={{paddingBottom:'0px'}}><b>{this.props.t('6')}</b></div>
                                        <div className="dots">
                                            <hr style={{marginTop:'0.5rem',marginBottom:'0.5rem'}}/>
                                        </div>
                                        <div className="instruction">{this.props.t('0')}1{this.props.t('5')}</div>
                                        <div className="login_inputs form-group" style={{height:'380px'}}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                                <div className="name_text"><b>{this.props.t('7')}</b></div>
                                                <div>
                                                    <input type="email" className="user_id_box form-control" placeholder="info@domain.com" value={this.state.email} onChange={this.updateValue.bind(this, "email")} onBlur={() => this.validator.showMessageFor(this.props.t('7'))} />
                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                        {this.validator.message(this.props.t('7'), this.state.email, 'required')}
                                                    </span>
                                                </div>
                                                <div>&nbsp;</div>

                                                <div className="input_name">
                                                    <button type="submit" id="step1" className="btn-lg button_size"
                                                        style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }}>
                                                        {this.props.t('11')}
                                                    </button>
                                                </div>
                                            </form>
                                            <br/>
                                            <br/>
                                            <div className="">
                                                {/*<GoogleLoginItem id={this.state.user_type} />*/}
                                                <GoogleFirebaseLogin id={this.state.user_type} />
                                                <br />
                                                {/*<FacebookLoginItem id={this.state.user_type} />*/}
                                                <FacebookFirebaseLogin id={this.state.user_type} />
                                            </div>
                                        </div>
                                        <div className="remember_text">
                                            {this.props.t('4')}
                                            <Link to={"/login/seller"} className="blue_text">{this.props.t('12')}</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-4">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" mt-5" >
                    <Footer />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sellerRegister: state.sellerRegister,
    errors: state.errors,
});


SellerRegistration = connect(mapStateToProps, { sellerRegister })(withRouter(SellerRegistration));

export { SellerRegistration };


 SellerRegistration = withTranslation('src_Components_Registration_SellerRegistration')(SellerRegistration);
